export default {

  required: {
    message : "Before creating your account, you must agree to our terms and conditions",
    fn      : (input)=> input
  }
}
